import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import MainPage from './Pages/MainPage/MainPage';


// Crear un tema dark personalizado con fondo negro
const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#000000', // Fondo negro para todo el tema
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Resetea los estilos por defecto del navegador */}
      <Box minHeight="100vh" display="flex" flexDirection="column">
        <MainPage />
      </Box>
    </ThemeProvider>
  );
};

export default App;
